// src/js/components/fam-icon-box.js

import { ICONS } from '../icons.js';

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-icon-box]").forEach(wrap => {
    const root = wrap.querySelector(".js-icon-box");
    if (!root) return;

    const wrapEl = root.querySelector(".js-icon-wrap");
    const svgEl = root.querySelector(".js-icon-svg");
    const titleEl = root.querySelector(".js-icon-title");

    const icon = wrap.dataset.boxIcon || "heart";
    const color = wrap.dataset.boxColor || "primary";
    const title = wrap.dataset.boxTitle || "";

    if (titleEl) titleEl.textContent = title;
    if (svgEl) svgEl.innerHTML = ICONS[icon] || ICONS['heart'];

    // Colores dinámicos
    root.classList.add(`border-t-4`, `border-t-${color}`);
    wrapEl.classList.add(`bg-${color}/10`);
    svgEl.classList.add(`text-${color}`);
  });
});
